module.exports = __webpack_public_path__ + "static/media/29DUNON6.184825b7.jpg";